import React from 'react'
import { useLocation } from 'react-router'
import { BugReportButton } from '@components/BugReportButton/BugReportButton'
import { LogoSingleLetter } from '@components/Logo/Logo'
import { NodeStatusButton } from '@components/NodeConnectionStatusPanel/ConnectionStatusButton'
import { ProfileCardButton } from '@components/ProfileCardButton/ProfileCardButton'
import { SearchBar } from '@components/SearchBar/SearchBar'
import { WalletButton } from '@components/WalletButton/WalletButton'
import { Membership } from '@towns-protocol/sdk'
import { Box, Stack } from '@ui'
import { useIsTradingEnabled } from 'hooks/useTradingEnabled'
import { PATHS } from 'routes'
import { useMyMembership, useSpaceContext } from 'use-towns-client'

import { PointsButton } from './PointsButton'

export const TopBar = () => {
    const location = useLocation()
    const { spaceId } = useSpaceContext()
    const membership = useMyMembership(spaceId)

    const isOnTownPage = location.pathname.startsWith(`/${PATHS.SPACES}/`)
    const isMember = membership === Membership.Join

    const shouldHideOnTownPage = isOnTownPage && spaceId && !isMember

    const noSearchBar =
        location.pathname === '/explore' || location.pathname === '/' || shouldHideOnTownPage
    const { isTradingEnabled } = useIsTradingEnabled()
    const showWalletButton = isTradingEnabled

    return (
        <Box padding="xs">
            <Box horizontal minHeight="x4">
                <Box
                    centerContent
                    width="x6"
                    tooltip="Go to towns.com"
                    tooltipOptions={{
                        placement: 'horizontal',
                        immediate: true,
                    }}
                    data-testid="towns-logo"
                >
                    <a
                        href="https://towns.com"
                        rel=", noopener noreferrer"
                        target="_blank"
                        style={{ lineHeight: '0' }}
                    >
                        <LogoSingleLetter />
                    </a>
                </Box>
                <Box centerContent width="x8" />
                <Box grow centerContent>
                    {!noSearchBar && <SearchBar />}
                </Box>

                <Stack horizontal gap="md" paddingRight="lg" alignItems="center">
                    <PointsButton />
                    {showWalletButton && <WalletButton />}
                    <NodeStatusButton />
                    <BugReportButton />
                    <ProfileCardButton />
                </Stack>
            </Box>
        </Box>
    )
}
